export default __webpack_public_path__ + "static/media/elle3.9079d3da.webp";